import * as React from 'react';

import styled from 'styled-components';

import { MerchCatalogItemColor } from '@services/merch/types/api/merch-catalog-item';

import MerchProduct from '../merch-product';
import { MerchProductColorSelect } from '../merch-product-color-select';

import Typography from '@components/basics/typography';
import Flex from '@components/layout/flex';

interface MerchProductSelectProps {
  className?: string;
  productImgSrc: string;
  productName: string;
  productDetail?: string;
  selected?: boolean;
  colors?: MerchCatalogItemColor[];
  onClick: () => void;
}

export const MerchProductSelect: React.FC<MerchProductSelectProps> = ({
  className,
  productImgSrc,
  productName,
  selected,
  colors = [],
  onClick,
}) => {
  const colorsArray = colors?.reduce((acc: string[], color) => {
    if (color.color && !acc.includes(color.color)) {
      return [...acc, color.color];
    }
    return acc;
  }, []);

  return (
    <MerchProduct
      onClick={onClick}
      className={className}
      productImgSrc={productImgSrc}
      selected={selected}
    >
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Title weight="700">
          {productName.length > 20
            ? `${productName.slice(0, 20)}...`
            : productName}
        </Title>
        {!!colorsArray.length && (
          <StyledMerchProductColorSelect colors={colorsArray} />
        )}
      </Flex>
    </MerchProduct>
  );
};

export default MerchProductSelect;

const Title = styled(Typography)`
  line-height: ${({ theme }) => theme.typography.h4};
  height: 100%;
  min-height: calc(${({ theme }) => theme.typography.h4} * 2);
  max-width: 50%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const StyledMerchProductColorSelect = styled(MerchProductColorSelect)`
  width: 50%;
`;
